import useLightMode from "./useLightMode"; // Import your custom useLightMode hook

export const useTheme = () => {
  const { theme } = useLightMode(); // Get the theme directly from useLightMode
  console.log(`useTheme: Current theme: ${theme}`);
  return theme; // Return the theme string directly
};
